export interface Article {
  id: string;
  title: string;
  slug: string;
  category: string;
  excerpt: string;
  content: string;
  coverImage: string;
  date: string;
  author: string;
  views: number;
  likes: number;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: "1",
    title: "苍井樱2024年度回顾：辉煌与成长的一年",
    slug: "2024-year-review",
    category: "news",
    excerpt: "回顾2024年，苍井樱在演艺事业上取得了令人瞩目的成绩。从年初的颁奖典礼到年末的粉丝见面会，每一个重要时刻都值得铭记。",
    content: `<p>2024年对于苍井樱来说，是充满挑战与收获的一年。在这一年里，她不仅在演艺事业上继续保持着高水准的表现，还积极参与了多项公益活动，展现出了作为公众人物的社会责任感。</p>
    <p>年初，苍井樱在东京国际电影节上获得了"最佳女演员"提名，这是对她多年来辛勤付出的肯定。随后，她发布的新作品《樱花季节》获得了广泛好评，在各大平台上的播放量突破了千万。</p>
    <p>在事业蒸蒸日上的同时，苍井樱也没有忘记回馈社会。她参与了"儿童教育基金"的慈善活动，为贫困地区的孩子们捐赠了图书和学习用品。</p>
    <p>年末的粉丝见面会上，苍井樱与来自全国各地的粉丝欢聚一堂，分享了这一年的心路历程。她表示："能够有这么多粉丝支持我，是我最大的幸福和动力。"</p>
    <p>展望2025年，苍井樱透露将有更多精彩作品与大家见面，让我们一起期待她的更多精彩表现！</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=A%20beautiful%20Japanese%20woman%20in%20elegant%20dress%20at%20a%20film%20award%20ceremony%2C%20warm%20golden%20stage%20lighting%2C%20soft%20bokeh%20background%2C%20glamorous%20atmosphere%2C%20editorial%20photography%20style%2C%20refined%20and%20sophisticated%20composition%2C%20warm%20cream%20and%20gold%20tones&width=1200&height=675&seq=article-2024-review&orientation=landscape",
    date: "2024-12-28",
    author: "编辑部",
    views: 12580,
    likes: 3421,
    tags: ["年度回顾", "2024", "苍井樱"],
  },
  {
    id: "2",
    title: "苍井樱最新写真集《樱之舞》正式发布",
    slug: "sakura-dance-photobook",
    category: "news",
    excerpt: "备受期待的苍井樱全新写真集《樱之舞》于本月正式发布。这本写真集收录了苍井樱在京都、奈良等古都拍摄的100余张精美照片。",
    content: `<p>经过长达半年的精心筹备，苍井樱全新写真集《樱之舞》终于与广大粉丝见面了。这本写真集由日本知名摄影师山田太郎掌镜，拍摄地点涵盖了京都、奈良等多个具有浓厚历史文化气息的古都。</p>
    <p>写真集以"樱花"为主题，将苍井樱清新脱俗的气质与日本传统美学完美融合。每一张照片都如同一幅精美的画作，展现出了她不同角度的美。</p>
    <p>在发布会上，苍井樱表示："《樱之舞》是我迄今为止最满意的一部写真集。在拍摄过程中，我深深感受到了日本传统文化的魅力，希望能够通过这本写真集，将这份美传递给每一位读者。"</p>
    <p>写真集分为精装版和平装版两个版本。精装版限量发售5000册，内含苍井樱亲笔签名和独家幕后花絮DVD，售价8800日元。平装版售价3800日元，在全国各大书店及线上平台均有销售。</p>
    <p>据悉，苍井樱还将于下月在东京、大阪两地举办写真集签售会，届时粉丝将有机会近距离接触偶像。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=A%20beautiful%20Japanese%20woman%20wearing%20traditional%20kimono%20under%20cherry%20blossom%20trees%20in%20Kyoto%2C%20soft%20pink%20petals%20falling%2C%20warm%20spring%20sunlight%2C%20dreamy%20atmospheric%20lighting%2C%20elegant%20and%20graceful%20composition%2C%20fine%20art%20photography%20style&width=1200&height=675&seq=article-photobook&orientation=landscape",
    date: "2024-11-15",
    author: "编辑部",
    views: 8930,
    likes: 2678,
    tags: ["写真集", "樱之舞", "京都"],
  },
  {
    id: "3",
    title: "苍井樱荣获年度最具影响力艺人称号",
    slug: "most-influential-artist-award",
    category: "news",
    excerpt: `在最新发布的年度艺人影响力榜单中，苍井樱凭借出色的作品质量和广泛的粉丝基础，荣获「年度最具影响力艺人」称号。`,
    content: `<p>由日本演艺协会主办的"年度艺人影响力评选"结果正式揭晓，苍井樱以压倒性的票数优势，荣获"年度最具影响力艺人"称号。这是她继2018年获得"最受欢迎女艺人奖"之后，再次获得行业重量级奖项。</p>
    <p>评选委员会表示，苍井樱在2024年度的表现令人印象深刻。她不仅在作品质量上保持着极高的水准，还通过积极的社交媒体互动和公益活动参与，展现出了强大的社会影响力。</p>
    <p>据统计，苍井樱在各大社交媒体平台上的粉丝总数已突破500万，其发布的内容月均互动量超过100万次。这些数据充分证明了她在粉丝群体中的巨大号召力。</p>
    <p>获奖后，苍井樱在社交媒体上发文感谢粉丝的支持："这个奖项属于每一位支持我的粉丝。没有你们的鼓励和陪伴，就没有今天的我。我会继续努力，用更好的作品回报大家的厚爱。"</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=A%20beautiful%20Japanese%20woman%20holding%20a%20crystal%20trophy%20on%20stage%2C%20elegant%20evening%20gown%2C%20spotlight%20illumination%2C%20prestigious%20award%20ceremony%20atmosphere%2C%20warm%20golden%20and%20cream%20tones%2C%20editorial%20photography%2C%20sophisticated%20composition&width=1200&height=675&seq=article-award&orientation=landscape",
    date: "2024-10-20",
    author: "编辑部",
    views: 6720,
    likes: 1890,
    tags: ["获奖", "最具影响力", "年度评选"],
  },
  {
    id: "4",
    title: "深度专访：苍井樱谈演艺之路与人生感悟",
    slug: "deep-interview-life-philosophy",
    category: "interview",
    excerpt: "在本次独家专访中，苍井樱首次深度分享了她从出道至今的心路历程，以及对演艺事业和人生的独特见解。",
    content: `<p>在东京一间安静的咖啡馆里，我们见到了苍井樱。与荧幕上的光鲜亮丽不同，私下的她更显温柔恬静。她微笑着向我们打招呼，那种自然亲切的态度让人瞬间放松下来。</p>
    <p><strong>关于出道初心</strong></p>
    <p>"其实我小时候是一个非常害羞的女孩，"苍井樱回忆道，"但是在舞台上表演的时候，我感觉自己完全变了一个人。那种能够自由表达的感觉，让我深深着迷。"</p>
    <p><strong>关于挑战与成长</strong></p>
    <p>谈到职业生涯中最大的挑战，苍井樱坦言："刚出道那两年是最艰难的。要适应公众的目光，要不断提升自己的专业能力，还要应对各种舆论压力。但正是这些经历，让我变得更加坚强。"</p>
    <p><strong>关于粉丝</strong></p>
    <p>"粉丝对我来说就像家人一样。"苍井樱的眼中闪烁着温暖的光芒，"每一次看到粉丝们为我加油打气，每一次收到他们用心准备的礼物和信件，我都感到无比的幸福和感动。他们是我坚持下去的最大动力。"</p>
    <p><strong>关于未来</strong></p>
    <p>对于未来，苍井樱有着清晰的规划："我希望能够尝试更多不同类型的作品，不断突破自我。同时，我也希望能够利用自己的影响力，为社会做一些有意义的事情。"</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=A%20beautiful%20Japanese%20woman%20sitting%20in%20a%20cozy%20cafe%2C%20natural%20window%20light%2C%20warm%20and%20intimate%20atmosphere%2C%20casual%20elegant%20outfit%2C%20soft%20cream%20and%20beige%20tones%2C%20editorial%20portrait%20photography%2C%20relaxed%20composition&width=1200&height=675&seq=article-interview&orientation=landscape",
    date: "2024-09-05",
    author: "特约记者 李美玲",
    views: 10540,
    likes: 3125,
    tags: ["专访", "深度访谈", "人生感悟"],
  },
  {
    id: "5",
    title: "苍井樱粉丝见面会盛况回顾",
    slug: "fan-meeting-highlights",
    category: "discussion",
    excerpt: "上周末，苍井樱在东京巨蛋举办了盛大的粉丝见面会，吸引了来自全球各地的数千名粉丝参加，现场气氛热烈非凡。",
    content: `<p>上周末的东京巨蛋，因为苍井樱而沸腾。这场期待已久的粉丝见面会，吸引了来自中国、韩国、东南亚乃至欧美的数千名粉丝齐聚一堂。</p>
    <p>见面会以苍井樱的最新单曲开场，她身着白色长裙缓缓走上舞台，瞬间点燃了全场的热情。在随后的两个小时里，苍井樱与粉丝们进行了亲密互动，包括问答环节、游戏互动和抽奖活动。</p>
    <p>最令人感动的是，苍井樱为每一位到场的粉丝都准备了亲手书写的小卡片。"我希望每一位来到现场的粉丝都能感受到我的心意，"她动情地说。</p>
    <p>见面会的高潮出现在尾声——苍井樱宣布了2025年亚洲巡回粉丝见面会的计划，将覆盖东京、首尔、上海、台北、曼谷和新加坡六个城市。这一消息让现场粉丝欢呼雀跃。</p>
    <p>来自上海的粉丝小王激动地表示："我从2019年就开始关注苍井樱了，今天终于能够亲眼见到她，真的太开心了！她的真诚和努力让我深受感动。"</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=A%20beautiful%20Japanese%20woman%20performing%20on%20a%20large%20concert%20stage%2C%20thousands%20of%20fans%20with%20glow%20sticks%2C%20grand%20scale%20event%2C%20dramatic%20stage%20lighting%2C%20energetic%20atmosphere%2C%20warm%20pink%20and%20golden%20tones%2C%20concert%20photography%20style&width=1200&height=675&seq=article-fanmeeting&orientation=landscape",
    date: "2024-08-18",
    author: "编辑部",
    views: 15320,
    likes: 4520,
    tags: ["粉丝见面会", "东京巨蛋", "现场回顾"],
  },
  {
    id: "6",
    title: "苍井樱经典作品推荐：入坑必看的十部佳作",
    slug: "top-10-must-watch-works",
    category: "works",
    excerpt: "对于刚认识苍井樱的新粉丝来说，从哪里开始了解她的作品是一个难题。本文为大家精选了十部最具代表性的作品，帮助你快速入门。",
    content: `<p>苍井樱出道多年来，参演了众多优秀作品。对于新粉丝来说，面对如此丰富的作品库可能会感到无从下手。作为资深粉丝，我们精心挑选了十部最具代表性的作品，希望能够帮助大家更好地了解苍井樱的魅力。</p>
    <p><strong>1.《初恋的回忆》（2016）</strong> - 苍井樱早期代表作，展现了她清纯动人的一面，是了解她演艺起点的最佳选择。</p>
    <p><strong>2.《东京爱情故事》（2017）</strong> - 这部作品让苍井樱获得了当年的最佳新人奖，她的表演令人印象深刻。</p>
    <p><strong>3.《樱花纷飞时》（2018）</strong> - 以樱花为主题的浪漫作品，画面唯美，剧情动人，是苍井樱颜值巅峰时期的代表作。</p>
    <p><strong>4.《午夜旋律》（2019）</strong> - 挑战全新角色类型，展现了她出色的演技广度。</p>
    <p><strong>5.《夏日的约定》（2020）</strong> - 轻松愉快的夏日故事，苍井樱在片中的笑容治愈了无数观众。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=A%20beautiful%20Japanese%20woman%20in%20romantic%20movie%20scene%2C%20cherry%20blossom%20petals%20floating%2C%20soft%20cinematic%20lighting%2C%20warm%20golden%20hour%20glow%2C%20dreamy%20atmosphere%2C%20film%20poster%20aesthetic%2C%20elegant%20composition&width=1200&height=675&seq=article-top10&orientation=landscape",
    date: "2024-07-22",
    author: "资深影评人 张伟",
    views: 20150,
    likes: 5678,
    tags: ["作品推荐", "入门指南", "经典回顾"],
  },
  {
    id: "7",
    title: "苍井樱在京都：一组令人惊艳的和服写真",
    slug: "kyoto-kimono-photoshoot",
    category: "gallery",
    excerpt: "苍井樱近日在社交媒体上分享了一组在京都拍摄的和服写真，优雅的姿态与古都的氛围完美融合，获得粉丝一致好评。",
    content: `<p>近日，苍井樱在个人社交媒体上分享了一组在京都拍摄的和服写真，迅速引发了粉丝的热烈讨论。这组照片由日本著名摄影师佐藤健一拍摄，取景地选在了京都最具代表性的清水寺、伏见稻荷大社和岚山竹林。</p>
    <p>照片中，苍井樱身着多套精美的和服，从华丽的振袖到素雅的访问着，每一种风格都被她演绎得恰到好处。她时而站在古老的寺庙前静静凝望，时而漫步在竹林小径中，每一个画面都如同一幅日本传统浮世绘。</p>
    <p>粉丝们纷纷在评论区留言称赞："苍井樱的和服造型太美了！""京都的古韵配上苍井樱的优雅，简直是绝配！""求原图当壁纸！"</p>
    <p>据悉，这组写真是为即将发行的2025年日历专门拍摄的，日历预计将于11月正式发售。除了京都篇之外，还有东京篇、北海道篇等多个系列，粉丝们可以期待更多精彩内容。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=A%20beautiful%20Japanese%20woman%20wearing%20elegant%20colorful%20kimono%20standing%20in%20front%20of%20ancient%20temple%20in%20Kyoto%2C%20traditional%20Japanese%20architecture%2C%20warm%20autumn%20sunlight%2C%20refined%20and%20graceful%20atmosphere%2C%20fine%20art%20portrait%20photography%2C%20soft%20cream%20and%20vermilion%20tones&width=1200&height=675&seq=article-kimono&orientation=landscape",
    date: "2024-06-10",
    author: "编辑部",
    views: 18200,
    likes: 6230,
    tags: ["和服写真", "京都", "日历"],
  },
  {
    id: "8",
    title: "苍井樱慈善行动：为灾区儿童送去温暖",
    slug: "charity-for-disaster-children",
    category: "news",
    excerpt: "苍井樱近日前往日本能登半岛地震灾区，为受灾儿童送去图书、文具和慰问金，用实际行动传递温暖与关爱。",
    content: `<p>在日本能登半岛地震发生后，苍井樱第一时间通过自己的慈善基金会向灾区捐赠了1000万日元。近日，她更是亲自前往灾区，为受灾儿童送去了温暖。</p>
    <p>在灾区临时安置点，苍井樱与孩子们一起画画、做游戏，耐心倾听他们讲述地震中的经历。她还在临时教室里为孩子们读故事书，用温柔的声音抚慰他们受伤的心灵。</p>
    <p>"看到这些孩子在如此艰难的环境中依然保持着纯真的笑容，我深受触动。"苍井樱在活动后接受采访时表示，"我希望通过自己的微薄之力，能够为他们的生活带来一些光亮。"</p>
    <p>除了物质上的帮助，苍井樱还宣布将与当地教育机构合作，设立"樱花奖学金"，资助受灾学生完成学业。这一举措得到了社会各界的广泛赞誉。</p>
    <p>苍井樱的粉丝们也积极响应偶像的号召，自发组织了线上募捐活动，短短三天就筹集了超过500万日元的善款。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=A%20beautiful%20Japanese%20woman%20reading%20books%20to%20children%20in%20a%20classroom%2C%20warm%20and%20caring%20atmosphere%2C%20soft%20natural%20light%2C%20heartwarming%20scene%2C%20documentary%20photography%20style%2C%20gentle%20cream%20and%20warm%20tones%2C%20intimate%20composition&width=1200&height=675&seq=article-charity&orientation=landscape",
    date: "2024-05-05",
    author: "编辑部",
    views: 9780,
    likes: 4120,
    tags: ["慈善", "地震", "公益"],
  },
];

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((a) => a.category === categorySlug);
};

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find((a) => a.slug === slug);
};

export const getRelatedArticles = (currentSlug: string, category: string, count: number = 3): Article[] => {
  return articles
    .filter((a) => a.category === category && a.slug !== currentSlug)
    .slice(0, count);
};

export const getLatestArticles = (count: number = 5): Article[] => {
  return [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, count);
};

export const getPopularArticles = (count: number = 5): Article[] => {
  return [...articles].sort((a, b) => b.views - a.views).slice(0, count);
};